<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="case">
    <div class="banner">
      <div class="contxt-area">
        <div class="title">研究报告</div>
        <div class="subtitle">行业洞察+趋势分析+营销方法论</div>
        <div class="desc">
          <section>
            基于十余年在数据抓取、策略指导、创意制作、社媒营销、内容管理与传播等新媒体营
          </section>
          <section>销全链路的丰富经验，为品牌主提供更全面的市场分析和营销洞察</section>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="list">
        <div v-for="(item,index) in firstNineCaseList" :key="item.id" class="item">
          <div v-if="item.url !== ''" class="item" @click="openUrl(index)">
            <div class="top">
              <img :src="item.small_image" alt="" />
            </div>
            <div class="bottom">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="desc">
                {{ item.subtitle }}
              </div>
            </div>
          </div>
          <router-link v-else :to="`/report/${item.id}`" class="item">
            <div class="top">
              <img :src="item.small_image" alt="" />
            </div>
            <div class="bottom">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="desc">
                {{ item.subtitle }}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Report } from '../../../../config/axios/new_api'
export default {
  data() {
    return {
      caseList: []
    }
  },
  mounted() {
    this.getReportList()
  },
  methods: {
    async getReportList() {
      const res = await Report.getReportList()
      if (res.data.status == 1) {
        this.caseList = res.data.data
      }
    },
    openUrl(index) {
      let text= this.$router.resolve({
        path: `/report-image?index=${index}`,
      });
      window.open(text.href, '_blank')
    }
  },
  computed: {
    firstNineCaseList() {
      return this.caseList.slice(0, 9)
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  background-image: url('http://file.microdreams.com/fe/pc/images/report/banner.png?x-oss-process=image/format,jpg/interlace,1/quality,Q_100');
  width: 100%;
  min-width: 1200px;
  height: 460px;
  margin-top: 60px;
  background-position-x: center;
  background-size: 1920px 460px;
  .contxt-area {
    width: 1200px;
    margin: auto;
    text-align: center;
  }
  .title {
    padding-top: 148px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #151b26;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
  }
  .subtitle {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #151b26;
    line-height: 33px;
    margin-bottom: 27px;
  }
  .desc {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #151b26;
    line-height: 25px;
  }
}
@media only screen and (min-width: 1920px) {
  .banner {
    background-size: cover;
  }
}

.content {
  margin: auto;
  padding-top: 80px;
  width: 1200px;
  > .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #151b26;
    line-height: 45px;
    text-align: center;
    margin-bottom: 48px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 56px;
    .item {
      overflow: hidden;
      width: 384px;
      height: 368px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #e8e6ee;
      margin-right: 24px;
      margin-bottom: 24px;
      cursor: pointer;

      &:nth-child(3n) {
        margin-right: 0;
      }
      .top {
        img {
          width: 384px;
          height: 200px;
          object-fit: cover;
        }
      }
      .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #151b26;
        line-height: 28px;
        margin-bottom: 14px;
        padding: 0 24px;
      }
      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #626371;
        line-height: 26px;
        max-height: 78px;
        overflow-y: auto;
        padding: 0 24px;
        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
          padding-right: 20px;
        }

        &::-webkit-scrollbar-thumb {
          background: #dddee0;
          border-radius: 4px;
        }

        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background: #fff;
        }
      }
      .bottom {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #626371;
        line-height: 26px;
        padding: 24px 0;
      }
    }
  }
}
</style>
